import {useState} from "react";
import CustomModal from '../CustomModal';
import VoucherForm from "./VoucherForm";
import React from 'react';

function Voucher() {
    const [modalOpen, setModalOpen] = useState(false);

    window.openVoucher = () => setModalOpen(true);

    const hideModal = () => {
        setModalOpen(false);
    }

    return (
        <>
            <CustomModal title={'Kursbuchung per Code'} open={modalOpen} onClose={hideModal}>
                <VoucherForm />
            </CustomModal>
        </>
    );
}

export default Voucher;
